
import React from "react";
import { SectionHeader } from "@/components/ui/section-header";
import { CountyCard } from "@/components/ui/county-card";
import { ArrowRight } from "lucide-react";
import { useFeaturedCounties } from "@/hooks/use-featured-counties";

export default function FeaturedCounties() {
  const {
    data: counties,
    isLoading,
    isError,
    error,
  } = useFeaturedCounties();

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <SectionHeader
          title="Find Nursing Homes by County"
          subtitle="Browse our comprehensive directory of quality nursing homes across Ireland, searchable by county."
          centered
        />

        {/* Loading & Error States */}
        {isLoading && (
          <div className="text-center py-8 text-grandpal-green-dark font-medium">
            Loading featured counties…
          </div>
        )}
        {isError && (
          <div className="text-center py-8 text-red-600 font-medium">
            Error loading counties: {error instanceof Error ? error.message : "Unknown error"}
          </div>
        )}

        {/* Main Listing */}
        {!isLoading && counties && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {counties.map((county) => (
              <CountyCard
                key={county.id}
                county={county.name}
                count={county.nursing_home_count ?? 0}
                imageUrl={county.image_url}
              />
            ))}
          </div>
        )}

        <div className="mt-12 flex flex-col items-center">
          <div className="flex flex-wrap justify-center gap-4 mb-6">
            <a
              href="/nursing-homes"
              className="inline-flex items-center text-grandpal-green-dark font-medium hover:text-grandpal-green-dark font-bold"
            >
              View all counties
              <ArrowRight className="h-5 w-5 ml-2" aria-hidden="true" />
            </a>
          </div>
          {/* CTA Banner */}
        </div>
      </div>
    </section>
  );
}
